import styled from 'styled-components'

const SeparatorLinkWord = styled.div`
  padding: 0 20px;
  display: inline-block;
  text-align: center;
  text-transform: ${props => props.theme.separator.transform || 'uppercase'};
  color: ${props => props.theme.separator.color};
  font-size: ${props => props.theme.separator.fontSize};
  line-height: ${props => props.theme.separator.lineHeight};
  font-family: ${props => props.theme.separator.family || 'inherit'};
`

export default SeparatorLinkWord
